import { render, staticRenderFns } from "./WorkspaceAiAssistantPanel.vue?vue&type=template&id=6a7d3780&scoped=true"
import script from "./WorkspaceAiAssistantPanel.vue?vue&type=script&lang=js"
export * from "./WorkspaceAiAssistantPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceAiAssistantPanel.vue?vue&type=style&index=0&id=6a7d3780&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7d3780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a7d3780')) {
      api.createRecord('6a7d3780', component.options)
    } else {
      api.reload('6a7d3780', component.options)
    }
    module.hot.accept("./WorkspaceAiAssistantPanel.vue?vue&type=template&id=6a7d3780&scoped=true", function () {
      api.rerender('6a7d3780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceAiAssistantPanel.vue"
export default component.exports